import { NgModule } from '@angular/core';

import { CustomerOrderInfoDialog } from './customer-order-info-dialog.component';
import { InfoFormComponent } from './info-form/info-form.component';

import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';
import { MaterialModule } from 'app/main/material.module';
import { DownloadModule } from 'app/components/download/download.module';
import { ShowOnMapModule } from 'app/main/auto/dialog/showonmap/show-on-map-dialog.module';

import { DialogHeaderModule } from 'app/components/dialogs/dialog-header/dialog-header.module';
import { ProgressInfoModule } from '../../orderinfo/progress-info/progress-info.module';

@NgModule({
    declarations: [
        CustomerOrderInfoDialog,
        InfoFormComponent,
    ],
    imports: [
        TranslateModule,
        FuseSharedModule,
        MaterialModule,
        DownloadModule,
        ShowOnMapModule,
        DialogHeaderModule,
        ProgressInfoModule,
    ],
    exports: [
        CustomerOrderInfoDialog,
        InfoFormComponent,
    ]
})

export class CustomerOrderInfoModule { }
